(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["delan-clean-footer"] && !Shopify.designMode) return;
  try {
    
function delanFooterSetup(root=document){
 root.querySelectorAll('.delan-footer-links').forEach(el=>{
  const media=window.matchMedia('(min-width:750px)');
  const sync=()=>{el.open=media.matches;};
  sync();media.addEventListener('change',sync);
 });
}
delanFooterSetup();
document.addEventListener('shopify:section:load',event=>delanFooterSetup(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["delan-gift-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('delan-gift-finder')) {
  customElements.define('delan-gift-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.status = this.querySelector('[role="status"]');
      this.results = this.querySelector('ul');
      this.strings = JSON.parse(this.querySelector('[data-gift-strings]').textContent);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.findGifts(); });
    }
    disconnectedCallback() { this.controller?.abort(); }
    async catalogue(signal) {
      const readPage = async page => {
        const url = new URL(`${this.dataset.root}collections/all`, location.origin);
        url.searchParams.set('view', 'delan-gift-data');
        url.searchParams.set('page', String(page));
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {signal, cache:'no-store'});
        if (!response.ok) throw new Error('catalogue');
        const data = JSON.parse(await response.text());
        if (!Array.isArray(data.products) || data.page !== page || !Number.isInteger(data.pages) || data.pages > 100) throw new Error('catalogue');
        return data;
      };
      const first = await readPage(1);
      const products = [...first.products];
      for (let page = 2; page <= first.pages; page += 4) {
        const batch = await Promise.all(Array.from({length:Math.min(4,first.pages-page+1)},(_,i)=>readPage(page+i)));
        for (const data of batch) {
          if (data.currency !== first.currency || data.pages !== first.pages) throw new Error('catalogue changed');
          products.push(...data.products);
        }
      }
      return {products:[...new Map(products.map(p => [p.id,p])).values()], currency:first.currency};
    }
    choose(products, budget, recipient) {
      const candidates = products.filter(p => p.available && !p.giftCard && p.price > 0 && p.price <= budget && p.url).map(p => {
        const text = `${p.title} ${p.type} ${p.tags.join(' ')}`.toLowerCase();
        const child = /\b(baby|babies|child|children|childrens|children's|kids)\b/.test(text);
        const him = /\b(mens|men's|gents|gent's|men)\b/.test(text);
        const her = /\b(ladies|lady|women|women's|womens)\b/.test(text);
        const category = ['earring','hoop','stud','creole','bangle','bracelet','ring','pendant','locket','chain','necklace','watch'].find(k => p.title.toLowerCase().includes(k)) || p.type;
        return {...p, child, him, her, category, score:((recipient === 'him' && him) || (recipient === 'her' && her) ? 2 : 0) + p.price / budget};
      }).filter(p => recipient === 'child' ? p.child : recipient === 'her' ? !p.child && !p.him : recipient === 'him' ? !p.child && !p.her : true).sort((a,b) => b.score-a.score || a.id-b.id);
      const chosen = [], counts = new Map();
      while (candidates.length && chosen.length < 10) {
        candidates.sort((a,b) => (b.score - (counts.get(b.category)||0)*0.7) - (a.score - (counts.get(a.category)||0)*0.7) || a.id-b.id);
        const p = candidates.shift(); chosen.push(p); counts.set(p.category,(counts.get(p.category)||0)+1);
      }
      return chosen;
    }
    async findGifts() {
      if (!this.form.reportValidity()) return;
      const budget = Math.round(Number(this.form.elements.budget.value)*100);
      if (!Number.isFinite(budget) || budget <= 0) return;
      const recipient = this.form.elements.recipient.value;
      this.controller?.abort();
      this.controller = new AbortController();
      const timer = setTimeout(() => this.controller.abort(), 45000);
      const button = this.form.querySelector('button');
      button.disabled = true; this.setAttribute('aria-busy','true');
      this.results.replaceChildren(); this.status.textContent = this.strings.loading;
      try {
        const {products,currency} = await this.catalogue(this.controller.signal);
        if (currency !== this.dataset.currency) throw new Error('currency');
        const chosen = this.choose(products,budget,recipient);
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency});
        for (const p of chosen) {
          const li = document.createElement('li'), a = document.createElement('a');
          const target = new URL(p.url, location.origin);
          if (target.origin !== location.origin || !target.pathname.includes('/products/')) continue;
          a.href = target.href;
          if (p.image) { const img = document.createElement('img'); img.src = p.image; img.alt = ''; img.width = 600; img.height = 600; img.loading = 'lazy'; a.append(img); }
          const title = document.createElement('h3'); title.textContent = p.title;
          const price = document.createElement('strong'); price.textContent = money.format(p.price/100);
          a.append(title,price);
          if (p.variant && p.variant !== 'Default Title') { const option = document.createElement('p'); option.textContent = `${this.strings.option} ${p.variant}`; a.append(option); }
          li.append(a); this.results.append(li);
        }
        this.status.textContent = chosen.length ? this.strings.found.replace('[count]',String(chosen.length)).replace('[budget]',money.format(budget/100)) : this.strings.empty;
      } catch (error) { this.status.textContent = this.strings.error; }
      finally { clearTimeout(timer); button.disabled = false; this.removeAttribute('aria-busy'); }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
